// removed by extract-text-webpack-plugin
module.exports = {"binary_button_container":"_3OZ1nLCbI3O0kIFMjvHrgv","raised":"_2P6M5evmhpeaedNBzbASHB","no_raised":"by3A4QbaTKl29ay4MjwuO","binary_button":"_123kYRdzd2fMwt5gQcaTqM","binary_button_icon":"xur3fi2YGBfzLqt5TiPWW","binary_button_indicator":"_3zOzfO2YpiSMeV7Y5wciVa","binary_button_number":"_6uwEMdp1z2r2JsI2U4gOA","binary_button_number_single":"Ubph9sj5Yx-Gz93YICWb2"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryButton/BinaryButton.scss
// module id = 2139
// module chunks = 1